import Badge from './badge.element.js';

export default Badge;

Badge.define('wje-badge', Badge);
